// Valida si los campos requeridos están completos según el tipo de adicional
export const validateAdicionalForm = (formData) => {
  if (!formData.tipo_adicional) return false;

  switch (formData.tipo_adicional) {
    case "PERSONA_CARGO":
      return !!(
        formData.nombre_completo &&
        formData.tipo_documento &&
        formData.numero_documento &&
        formData.parentesco &&
        formData.edad
      );

    case "SOCIEDADES_PROCESO":
      return !!(
        formData.nombre_completo &&
        formData.tipo_documento &&
        formData.numero_documento &&
        formData.direccion_notificacion
      );

    case "PROCESO_JUDICIAL":
      return !!(
        formData.juzgado &&
        formData.correo &&
        formData.demandante &&
        formData.demandado &&
        formData.radicado &&
        formData.estado_actual
      );

    default:
      return false;
  }
};

// Formatea los datos del adicional para la vista
export const formatAdicionalData = (adicional) => {
  switch (adicional.tipo_adicional) {
    case "PERSONA_CARGO":
      return {
        ...adicional,
        titulo: adicional.nombre_completo,
        subtitulo: `${adicional.tipo_documento} - ${adicional.numero_documento}`,
        detalles: [
          { label: "Parentesco", value: adicional.parentesco },
          { label: "Edad", value: `${adicional.edad} años` },
        ],
      };

    case "SOCIEDADES_PROCESO":
      return {
        ...adicional,
        titulo: adicional.nombre_completo,
        subtitulo: `${adicional.tipo_documento} - ${adicional.numero_documento}`,
        detalles: [
          {
            label: "Identificacion",
            value: `${adicional.tipo_documento} - ${adicional.numero_documento}`,
          },
          { label: "Dirección", value: adicional.direccion_notificacion },
        ],
      };

    case "PROCESO_JUDICIAL":
      return {
        ...adicional,
        titulo: adicional.juzgado,
        subtitulo: `Rad. ${adicional.radicado}`,
        detalles: [
          { label: "Demandante", value: adicional.demandante },
          { label: "Demandado", value: adicional.demandado },
          { label: "Estado", value: adicional.estado_actual },
          { label: "Correo", value: adicional.email },
        ],
      };

    default:
      return adicional;
  }
};

// Prepara los datos del adicional para enviar al servidor
export const prepareAdicionalData = (formData, procesoId) => {
  const commonData = {
    proceso: procesoId,
    tipo_adicional: formData.tipo_adicional,
  };

  switch (formData.tipo_adicional) {
    case "PERSONA_CARGO":
      return {
        ...commonData,
        nombre_completo: formData.nombre_completo,
        tipo_documento: formData.tipo_documento,
        numero_documento: formData.numero_documento,
        parentesco: formData.parentesco,
        edad: parseInt(formData.edad, 10),
      };

    case "SOCIEDADES_PROCESO":
      return {
        ...commonData,
        nombre_completo: formData.nombre_completo,
        tipo_documento: formData.tipo_documento,
        numero_documento: formData.numero_documento,
        direccion_notificacion: formData.direccion_notificacion,
      };

    case "PROCESO_JUDICIAL":
      return {
        ...commonData,
        juzgado: formData.juzgado,
        correo: formData.correo.trim().toLowerCase(),
        demandante: formData.demandante,
        demandado: formData.demandado,
        radicado: formData.radicado,
        estado_actual: formData.estado_actual,
      };

    default:
      return commonData;
  }
};

// Constantes para tipos de documentos
export const TIPOS_DOCUMENTO = [
  { value: "RC", label: "Registro Civil" },
  { value: "CC", label: "Cédula de Ciudadanía" },
  { value: "CE", label: "Cédula de Extranjería" },
  { value: "TI", label: "Tarjeta de Identidad" },
  { value: "NIT", label: "Número de Identificación Tributaria" },
  { value: "PAS", label: "Pasaporte" },
];

// Constantes para tipos de parentesco
export const TIPOS_PARENTESCO = [
  { value: "HIJO", label: "Hijo/a" },
  { value: "PADRE", label: "Padre" },
  { value: "MADRE", label: "Madre" },
  { value: "HERMANO", label: "Hermano/a" },
  { value: "ABUELO", label: "Abuelo/a" },
  { value: "OTRO", label: "Otro" },
];

// Constantes para estados de procesos judiciales
export const ESTADOS_PROCESO = [
  { value: "ACTIVO", label: "Activo" },
  { value: "INACTIVO", label: "Inactivo" },
  { value: "EN_TRAMITE", label: "En Trámite" },
  { value: "SUSPENDIDO", label: "Suspendido" },
  { value: "TERMINADO", label: "Terminado" },
];

// Función auxiliar para validar correo electrónico
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Función auxiliar para validar número de documento
export const validateDocumento = (identificacion, tipo) => {
  if (tipo === "NIT" || tipo === "CC" || tipo === "CE" || tipo === "RC") {
    return /^\d{7,12}$/.test(identificacion); // Permitir máximo 12 dígitos y minimo 7 digitos
  } else if (tipo === "PAS") {
    return /^[a-zA-Z0-9]{6,20}$/.test(identificacion); // Permitir alfanumérico entre 6 y 20 caracteres
  } else if (tipo === "TI") {
    return /^\d+$/.test(identificacion); // Solo dígitos, sin límite de longitud
  }
  return false;
};

// Función auxiliar para validar edad
export const validateEdad = (edad) => {
  const edadNum = parseInt(edad, 10);
  return !isNaN(edadNum) && edadNum >= 0 && edadNum <= 120;
};

// Función auxiliar para validar radicado
//export const validateRadicado = (radicado) => radicado.trim().length === 23;
export const validateRadicado = (radicado) => {
  // Remover guiones y espacios, luego validar 23 caracteres alfanuméricos
  const radicadoLimpio = radicado.replace(/[- ]/g, "");
  return /^[A-Za-z0-9]{23}$/.test(radicadoLimpio);
};
